import React, { useEffect, useState } from "react";
import styles from "./StepOne.module.css";
import Header from "../../Header/Header";
// import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInputField from "../../../components/PhoneInput/PhoneInput";
import { useProfile } from "../../../contexts/ProfileContext";
import { validateUSPhoneNumber, showErrorToast } from "../../utils";
const StepOneInsurance = () => {
    const navigate = useNavigate();
    const { profileData: profile } = useProfile();
    // State variables to capture form input
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");

    const storageInfo = JSON.parse(sessionStorage.getItem("insuranceInfo"));
    useEffect(() => {}, []);

    useEffect(() => {
        if (storageInfo?.generalInfo) {
            const generalInfo = storageInfo.generalInfo;
            setFirstName(generalInfo.firstName);
            setLastName(generalInfo.lastName);
            setPhoneNumber(generalInfo.phoneNumber ? generalInfo.phoneNumber : "+1");
            setEmail(generalInfo.email);
        } else {
            setFirstName(profile?.first_name);
            setLastName(profile?.last_name);
            // Ensure phone number is properly formatted for US
            if (profile?.phone) {
                const digitsOnly = profile.phone.replace(/\D/g, "");
                if (digitsOnly.length === 10) {
                    setPhoneNumber("1" + digitsOnly);
                } else if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
                    setPhoneNumber(digitsOnly);
                } else {
                    setPhoneNumber(profile.phone);
                }
            } else {
                setPhoneNumber("1");
            }
            setEmail(profile?.email);
        }
    }, [profile]);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Validate form inputs
        if (!validateForm()) return;

        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            sessionStorage.setItem("insuranceInfo", JSON.stringify({ ...storageInfo, generalInfo: { firstName, lastName, phoneNumber, email } }));
            navigate("/services/insurance-quote/step-2");
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Insurance Services | ${config.get("COMPANY_NAME")}`;
    }, []);

    const validateForm = () => {
        if (!firstName || !lastName || !phoneNumber || !email) {
            showErrorToast("Please fill in all fields.");
            return false;
        }
        if (!validateUSPhoneNumber(phoneNumber)) {
            showErrorToast("Please enter a valid US phone number.");
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showErrorToast("Please enter a valid email address.");
            return false;
        }

        return true;
    };

    return (
        <div className={`${styles.container}  tw-bg-background_color tw-overflow-y-auto`}>
            <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                <Header title="Apply For Insurance" />
                <section className={styles.formSection}>
                    {/* <ProgressBar currentStep={1} totalSteps={7} /> */}
                    <div className={`${styles.formContainer} tw-px-5 tw-items-center`}>
                        <h1 className={styles.formTitle}>General Information</h1>
                        {/* <p className="tw-font-semibold">Help us connect you with the perfect insurance partner.</p> */}
                        <p className={`${styles.formDescription}  max-sm:tw-text-justify`}>
                            Your information is safe with us securely used to generate accurate, personalized insurance quotes tailored to your needs.
                            We value your privacy and will never share your details without your consent.
                        </p>
                        <form className={`${styles.generalForm} tw-w-full `} onSubmit={handleSubmit}>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>First Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your First name"
                                        value={firstName}
                                        required={true}
                                        onChange={(e) => {
                                            if (e.target.value.length > 50) {
                                                e.target.value = e.target.value.slice(0, 50);
                                                setFirstName(e.target.value);
                                            } else {
                                                setFirstName(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Last Name</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your Last name"
                                        value={lastName}
                                        required={true}
                                        onChange={(e) => {
                                            if (e.target.value.length > 50) {
                                                e.target.value = e.target.value.slice(0, 50);
                                                setLastName(e.target.value);
                                            } else {
                                                setLastName(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Phone Number</label>
                                    <PhoneInputField phone={phoneNumber} setPhone={(val) => setPhoneNumber(`+${val}`)} />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Email Address</label>
                                    <input
                                        type="email"
                                        className={styles.fieldInput}
                                        placeholder="Enter your Email Address"
                                        value={email}
                                        required={true}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <p className="tw-text-secondary tw-italic max-sm:tw-text-[12px] max-sm:tw-text-justify">
                                Your privacy is our priority. We’ll never share your information without your explicit consent{" "}
                            </p>
                            <div className="tw-flex tw-justify-center tw-w-full">
                                <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover tw-w-fit`}>
                                    Next: Property Details
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default StepOneInsurance;
